import React, { Component } from "react";
import { connect, useSelector } from "react-redux";
import CasesPage from "./CasesPage";
function Cases(props) {
  const user = useSelector((state) => state.appReducer.userDataReducer.data);
  const { subject: user_id, GroupRole: groupRole } = user;
  const { id: group_id, Members: groupMembers } = user.Group;

    return (
      <div>
        <CasesPage user_id={user_id} groupRole={groupRole} group_id={group_id} groupMembers={groupMembers} />
      </div>
    );
  }

export default Cases;
